import React from 'react';
import OccupationCard from './OccupationCard';
import { Occupation } from '../types';
interface OccupationCardGridProps {
  occupationSalaries: Occupation[];
  loading: boolean;
  selectedOccupationCard: Occupation | null;
  setSelectedOccupationCard: (occupation: Occupation | null) => void;
}

const OccupationCardGrid: React.FC<OccupationCardGridProps> = ({
  occupationSalaries,
  loading,
  selectedOccupationCard,
  setSelectedOccupationCard,
}) => {
  const handleCardSelect = (occupation: Occupation) => {
    // Toggle selection: if already selected, unset it, otherwise set it
    if (selectedOccupationCard === occupation) {
      setSelectedOccupationCard(null);
    } else {
      setSelectedOccupationCard(occupation);
    }
  };

  if (loading) {
    return (
      <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
        <div className='col-span-1 md:col-span-2 flex flex-col items-center justify-center bg-white rounded-lg shadow p-8'>
          <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mb-4'></div>
          <p className='text-gray-600 font-body-16'>
            Loading occupation data...
          </p>
          <p className='text-gray-500 font-body-14 mt-2'>
            This may take a few moments
          </p>
        </div>
      </div>
    );
  }

  if (!occupationSalaries.length) {
    return (
      <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
        <div className='col-span-1 md:col-span-2 bg-white rounded-lg shadow p-6 text-center'>
          <div className='text-gray-500 font-body-16 mb-2'>
            No matching occupation data based on your current selections.
          </div>
          <div className='text-gray-400 font-body-14'>
            Try selecting a different category or subject to view potential
            salary insights.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='grid grid-cols-2 gap-4'>
      {occupationSalaries.map((occupation, index) => (
        <OccupationCard
          key={`${occupation.onetSocCode}-${index}`}
          index={index}
          occupation={occupation}
          isSelected={selectedOccupationCard === occupation}
          onSelect={handleCardSelect}
        />
      ))}
    </div>
  );
};

export default OccupationCardGrid;
